import axios from "axios";
import { buildQuery } from "utils/queryUtils";

export const findLanguages = (headers, params) => {
    let query = buildQuery(params, ["code", "name"]);
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/languages${query}`, {
        headers,
    });
};

export const findLanguagesById = (headers, id) => {
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/languages/${id}`, {
        headers,
    });
};
